import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">The Big Five</div>
                                            <p>It’s easier to remember the ‘Big Five’ using the acronym OCEAN.
                                                They’re as follows:</p>
                                            <div className="circleBottomPadding ">
                                                <div className="verticalword "><span
                                                    className="greennumberroundbg ifloatCircle">O</span></div>
                                                <span className="circledesrption verticalContentPadding">
    <p><span className="subtiltereg ">Openness to experience</span></p>
    <p>Openness to Experience describes a dimension of personality that distinguishes
imaginative, creative people from down-to-earth, conventional people. ‘Open’ people tend
to be intellectually curious, appreciative of culture and aware of their feelings. They
therefore tend to hold unconventional and individualistic beliefs, although their actions may
be conforming. People with low scores for ‘openness to experience’ tend to have narrow,
commonplace interests. They prefer the plain, straightforward and obvious to what is
complex, ambiguous or subtle. They prefer the familiar to the novel, and are resistant
to change.</p></span></div>

                                            <div className="circleBottomPadding">
                                                <div className="verticalword"><span
                                                    className="greennumberroundbg ifloatCircle">C</span></div>
                                                <span className="circledesrption verticalContentPadding">
    <p><span className="subtiltereg ">Conscientiousness</span></p>
    <p>This is about regulating and directing our impulses. Conscientious individuals tend to avoid
trouble and achieve success through purposeful planning and persistence. They’re
regarded by others as intelligent and reliable, but can, if they veer towards perfectionism or
‘workaholism’, be thought stuffy or boring. Unconscientious people may be criticised as
unreliable, unambitious and unconventional, but they’ll experience many short-lived
pleasures and are often considered by others to be colourful, spontaneous and fun to
be with.</p></span></div>

                                            <div className="circleBottomPadding">
                                                <div className="verticalword"><span
                                                    className="greennumberroundbg ifloatCircle">E</span></div>
                                                <span className="circledesrption verticalContentPadding">
    <p><span className="subtiltereg ">Extroversion</span></p>
    <p>Extroverts engage strongly with the external world. They’re energised by others, often have
a positive outlook and tend to be enthusiastic, action-oriented individuals. In groups they
like to talk and assert themselves. The opposite of extroversion is introversion, and those
with this tendency are likely to be quiet, low-key, deliberate, and less dependent on external
stimuli – they gain their energy from within. Their lack of social involvement should not be
interpreted as shyness or depression; the introvert simply needs less stimulation than an
extrovert and more time alone.</p></span></div>

                                            <div className="circleBottomPadding">
                                                <div className="verticalword"><span
                                                    className="greennumberroundbg ifloatCircle">A</span></div>
                                                <span className="circledesrption verticalContentPadding">
    <p><span className="subtiltereg ">Agreeableness</span></p>
    <p>Agreeable individuals have an optimistic view of others and value getting along with them.
They’re therefore considerate, friendly, generous, helpful and willing to compromise. They
tend to believe that people are basically honest, decent and trustworthy. Disagreeable
individuals place their own interests above those of others, are generally unconcerned with
their fellows’ wellbeing and less likely to extend themselves on another’s behalf. Scepticism
about others’ motives can make them suspicious, unfriendly or uncooperative.</p></span></div>

                                            <div className="circleBottomPadding">
                                                <div className="verticalword"><span
                                                    className="greennumberroundbg ifloatCircle">N</span></div>
                                                <span className="circledesrption verticalContentPadding">
        <div className="tablepadding">
        <p><span className="subtiltereg ">Neuroticism</span></p>
    <p>Neuroticism is an emotionally negative tendency. Emotional response to events will be
more intense than others’ and more likely to be negatively interpreted. Minor frustrations
may be exaggerated. Conversely, individuals who score low in Neuroticism tend to be calm
and less negative or emotionally reactive. This doesn’t, however, mean they could be
described as particularly ‘positive’, which is a characteristic of extroversion.</p></div></span></div>


                                            <div className="border_subtitle supLinesapce">Understanding your
                                                personality profile will help you to determine your preferred
                                                learning styles, in line with Kolb’s experiential learning
                                                theory
                                            </div>
                                            <p>On the following pages we’ve provided a self-analysis
                                                questionnaire which, while not validated,
                                                will indicate your strongest tendencies. This will help define
                                                which learning style you prefer.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}